<script setup lang="ts">
import { Form } from "@inertiajs/vue3"

import DatePicker from "@/components/custom/DatePicker.vue"
import FileInput from "@/components/custom/FileInput.vue"
import FormField from "@/components/custom/FormField.vue"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { teleworkPath } from "@/routes"
import type { Telework } from "@/types/serializers"

defineProps<{
  itemType: Telework["item_type"]
}>()

defineEmits<{
  success: []
}>()

const today = new Date()
const minDate = new Date(today.getFullYear(), 0, 1, 0, 0, 0, 0)
</script>

<template>
  <Form
    method="post"
    :action="teleworkPath()"
    disable-while-processing
    class="mt-4 flex flex-col gap-2"
    autocomplete="off"
    #default="{ errors }"
    @success="$emit('success')"
  >
    <input name="item_type" :value="itemType" hidden />
    <FormField
      name="item_name"
      label="Marco\Modelo"
      :errors="errors[itemType]?.item_name"
      required
    >
      <Input name="item_name" placeholder="Ej: Sony WH-CH720" />
    </FormField>

    <FormField
      name="purchase_date"
      label="Fecha de compra"
      :errors="errors[itemType]?.purchase_date"
      required
    >
      <DatePicker name="purchase_date" :min-date="minDate" :max-date="today" />
    </FormField>

    <FormField
      name="price"
      type="number"
      label="Precio"
      :errors="errors[itemType]?.price"
      required
    >
      <Input name="price" type="number" />
    </FormField>

    <FormField
      name="factura"
      label="Factura"
      :errors="errors[itemType]?.factura"
      required
    >
      <FileInput name="factura" accept="image/*,application/pdf" />
    </FormField>

    <Button type="submit" class="w-fit"> Enviar </Button>
  </Form>
</template>
